import { useDrop, useDrag } from 'react-dnd';
import { BaseItem } from './types';

export const useDnd = (item: BaseItem, onDrop: ((sourceId: string, targetId: string) => void) | undefined) => {
  const [{ canDrop, isOver }, drop] = useDrop(() => ({
    enabled: item.droppable,
    accept: 'row',
    drop: () => ({ id: item.id }),
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }));

  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'row',
    item,
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult<{ id: string }>();
      if (item && dropResult) {
        onDrop?.(item.id, dropResult.id);
      }
    },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
      handlerId: monitor.getHandlerId(),
    }),
  }));

  const canBeDropped = canDrop && item.droppable;
  const aboutToBeDropped = canBeDropped && isOver;

  return {
    canBeDropped,
    aboutToBeDropped,
    isDragging,
    ref: item.draggable ? drag : drop,
  };
};
